import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import TextFieldInlineEdit from './TextFieldInlineEdit';
import { issueAttributesType } from '../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES } from '../constants/issue-attribute-names';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';

class LocationDescriptionInlineEdit extends PureComponent {
  render() {
    const { issue, className, styleType, horizontalAlign } = this.props;

    const noLocationDescriptionText = T.translate('unspecifiedValue');
    const label = T.translate('new.location');

    return (
      <TextFieldInlineEdit
        issue={issue}
        className={className}
        label={label}
        placeholder={noLocationDescriptionText}
        attributeName={ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION}
        styleType={styleType}
        horizontalAlign={horizontalAlign}
      />
    );
  }
}

LocationDescriptionInlineEdit.displayName = 'LocationDescriptionInlineEdit';

LocationDescriptionInlineEdit.propTypes = {
  issue: issueAttributesType,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  horizontalAlign: PropTypes.bool,
};

export default LocationDescriptionInlineEdit;
